import { css } from '@emotion/css';
import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react';
import colors from '@/theme/colors';

export const LoadingSpinner: React.FC = () => {
  const [isAriaHidden, setIsAriaHidden] = useState(false);
  const [liveMessage, setLiveMessage] = useState<string>("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsAriaHidden(true);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const announceLoading = () => {
      setLiveMessage("Loading... Please wait.");
      setTimeout(() => setLiveMessage(""), 1000);
    };

    announceLoading();
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={styles.container}
    >
      <span aria-hidden={isAriaHidden}>
         <CircularProgress
          role="img"
          aria-label="Loading"
          style={{
            color: colors.leaf,
          }}
        />
      </span>
      <span className="sr-only">{liveMessage}</span>
    </div>
  );
}

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center ;
    height: 60px;
  `,
}
